<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-text-field
          label="Фамилия"
          outlined
          v-model.trim="v.lastName.$model"
          :errorMessages="getValidationErrorText(v.lastName)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Имя"
          outlined
          v-model.trim="v.firstName.$model"
          :errorMessages="getValidationErrorText(v.firstName)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Отчество (при наличии)"
          outlined
          v-model.trim="v.patronymic.$model"
          :errorMessages="getValidationErrorText(v.patronymic)"
        />
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model="v.snils.$model"
          :errorMessages="getValidationErrorText(v.snils)"
          label="СНИЛС"
          v-mask="['###-###-### ##']"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          label="ИНН"
          v-mask="['############']"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <AddressStructuredField
          @change="v.address.$model = $event"
          :value="v.address.$model"
          :v="v.address"
          label="Место жительства"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import AddressStructuredField, {
  addressValidate,
} from '@/components/base/AddressStructuredField';
import {
  getValidationErrorText,
  EMAIL,
  MAX_LENGTH,
  MAX_LENGTH_EMAIL,
  MinLength,
  INN,
  PERSON_NAME,
} from '@/utils/validate';

export const personModel = {
  lastName: '',
  firstName: '',
  patronymic: '',

  address: '',

  email: '',
  snils: '',
  inn: '',
};

export const personValidation = {
  lastName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  firstName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  patronymic: {
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  snils: {
    required,
    minLength: minLength(MinLength.SNILS),
  },
  inn: {
    required,
    minLength: minLength(12),
    INN: INN(12),
  },
  email: {
    required,
    EMAIL,
    maxLength: maxLength(MAX_LENGTH_EMAIL),
  },
  address: {
    required,
    ...addressValidate(),
  },
};

export default {
  name: 'Person',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    AddressStructuredField,
  },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>
